import * as types from './state/types';
import * as UITypes from '../../common/UI/state/types';
import * as Constants from './helpers/constants';
import { UPDATE_SERVING_SITE_MEAL_COUNT } from 'PointOfSale/modules/setDateAndSite/state/types';

/**
 * Evaluate the signalR response and parse into object.
 *
 * @param {*} data
 */
export const parseMessage = (data) => {
  const { Message, Status, Source, ...otherData } = data;

  return { Message, Status, Source, Type: 'progressMessage', ...otherData };
};

// This matches the HubSourceEnum in the api.
const HubSourceEnum = {
  Progress: 0,
  Alert: 1,
  InProcProgress: 2, //same process progress without use of handfire
  InProcProgressCompleted: 3, //a notification source to notify job done
  UpdateMealCount: 4, //a notification which updates the meal count for a site.
};

/**
 * Dispatch the correct redux action based on the Source of message.
 *
 * @param {*} payload
 *
 * @todo const list of Sources to map
 */
export const signalRMessageHandler = (message, dispatch) => {
  if (Constants.SUPPORT_MESSAGE_TITLES.includes(message.Message.Title)) {
    console.log(message.Message.Description);
    return null;
  }
  switch (message.Source) {
    case HubSourceEnum.Progress:
      return dispatch({
        type: UITypes.UI_SIDEBAR_ADD_MESSAGE,
        payload: parseMessage(message),
      });
    case HubSourceEnum.Alert:
      return dispatch({
        type: UITypes.UI_NOTIFICATION_ADD_MESSAGE,
        payload: parseMessage(message),
      });
    case HubSourceEnum.InProcProgress:
      return dispatch({
        type: UITypes.UI_CENTER_ADD_MESSAGE,
        payload: parseMessage(message),
      });
    case HubSourceEnum.InProcProgressCompleted:
      return dispatch({
        type: UITypes.UI_REDIRECT_URL,
        payload: parseMessage(message),
      });
    case HubSourceEnum.UpdateMealCount:
      return dispatch({
        type: UPDATE_SERVING_SITE_MEAL_COUNT,
        payload: message.Data,
      });
    default:
      return dispatch({
        type: types.SIGNALR_RECEIVE_MESSAGE,
        payload: message,
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/SignalR/MessageHandler.js